import React from "react";

import { TranslationLibraryControlDetails } from "../translation_library_control_details";
import AiTranslationDetails from "./ai_translation_details";

export default function NewTranslationModalContent(props) {
  const { control, language, currentLanguage } = props.newTranslation;

  return (
    <div className="new-translation-content">
      <label>{currentLanguage.text}</label>
      <div className="new-translation-section">
        <TranslationLibraryControlDetails control={control} />
      </div>
      <AiTranslationDetails control={control} language={language} />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/new_translation_modal/new_translation_modal_content.js